import WrappedForm from '@/components/formEditor/wrappedForm.vue'

export default {
  components: {
    WrappedForm
  },
  props: {
    show: {
      type: Boolean,
      default: true
    },
    candidateInfo: {
      required: true
    },
    isTemplate: {
      type: Boolean,
      default: false
    },
    isEditMode: {
      type: Boolean,
      default: false
    },
    jobId: {
      required: false
    }
  },
  data () {
    return {
      i18nPrefix: 'admin.application.candidate',
      hasForm: true,
      loading: false,
      hasChangedData: false,
      stepData: {},
      resetPromise: null
    }
  },
  computed: {

  },
  created () {

  },
  mounted () {

  },
  methods: {
    async setStepDataToCandidateInfo () {

    },
    async getStepData () {

    },
    async resetForm () {
      this.loading = true
      let resetPromiseResolve = null
      this.resetPromise = new Promise((resolve) => {
        resetPromiseResolve = resolve
      })
      this.stepData = await this.getStepData()
      await this.$nextTick()
      this.clearValidate()
      this.hasChangedData = false
      this.loading = false
      resetPromiseResolve()
      this.resetPromise = null
    },
    async clearCustomValidate () {

    },
    async clearValidate () {
      if (this.hasForm) {
        let form = this.$refs.form
        if (!form) {
          await this.$nextTick()
          form = this.$refs.form
        }
        if (!form) {
          return
        }
        await form.clearValidate()
      }
      this.clearCustomValidate()
    },
    async customValidate () {
      return true
    },
    async validate () {
      let isValid = true
      if (this.hasForm) {
        isValid = await this.$refs.form.submit()
      }
      if (isValid) {
        isValid = await this.customValidate()
      }
      return Boolean(isValid)
    },
    async submit (ignoreError) {
      if (this.loading) {
        return
      }
      this.loading = true
      try {
        if (this.resetPromise) {
          await this.resetPromise
        }
        const isValid = await this.validate()
        if (ignoreError || isValid) {
          await this.setStepDataToCandidateInfo()
          this.hasChangedData = false
        }
        return isValid
      } finally {
        this.loading = false
      }
    }
  },
  watch: {
    show: {
      immediate: true,
      handler () {
        if (this.show) {
          this.$nextTick(() => {
            this.$emit('reset', this.resetForm())
          })
        }
      }
    },
    stepData: {
      deep: true,
      handler () {
        this.hasChangedData = true
      }
    }
  }
}
